(ns teamoesterreich.admin-mode.ui-helper.check-box
  (:require [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.util.helper :as h]
            [reagent-material-ui.icons.indeterminate-check-box-outlined :refer [indeterminate-check-box-outlined]]
            [reagent-material-ui.icons.check-box-outline-blank :refer [check-box-outline-blank]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.check-box :refer [check-box]]
            ))


(defn filter-check-box [!waiting? !loaded? !filter name filter-key]

  [mui/form-control-label {:label   name :value "dst" :placement "start"
                           :control (r/as-element [mui/checkbox {:checked  (get-in @!filter [filter-key])
                                                                 :onChange (h/wait-do-check !waiting? (fn [val] (swap! !filter assoc filter-key val)) !loaded?)
                                                                 }])}]
  )


(defn onOff-filter-check-box [!waiting? !loaded? !filter name filter-key]
  [mui/form-control-label {:label   (r/as-element [:span {:style {:fontSize "smaller" :overflow "none" :white-space "nowrap"}} name])
                           :value   (get @!filter key) :placement "start"
                           :control (r/as-element
                                      [mui/icon-button {

                                                        :onClick (h/wait-do-check !waiting? (fn [_]
                                                                                              (let [val (case (get @!filter filter-key)
                                                                                                          1 -1
                                                                                                          -1 nil
                                                                                                          1)]
                                                                                                (println "set onOff-filter-check-box " @!filter filter-key val)
                                                                                                (swap! !filter assoc filter-key val)
                                                                                                )) !loaded?)
                                                        }
                                       (case (get @!filter filter-key)
                                         1 [check-box {:style {:color "green"}}]
                                         -1 [indeterminate-check-box-outlined {:style {:color "red"}}]
                                         [check-box-outline-blank {}])
                                       ]

                                      )}])









